import axios from 'axios';
import {API_URL} from '../../../constants';
import { toast } from 'react-toastify';

export const FLAG_RESTRINGE_GUARDAR_POR_INCUMPLIMIENTO = true;

// Roles de negocio en TRXROL (nTipSistema=4650) que reemplazan a los antiguos
// parámetros RES_CMS_APROBADOR / RES_CMS_PUBLICADOR de tblParametro.
export const ROL_APROBADORES_DOCUMENTO = 1071;
export const ROL_PUBLICADORES_DOCUMENTO = 1072;

export const fetchImageDimensions = async () => {
    const url = `${API_URL}ParametroUX/ListarParametrosPorCodigo/RECURSOS_IMG_MAXDIM`; 
    try {
        const res = await axios.get(url);
        if (res.data && res.data.isSucess && res.data.result && res.data.result.length > 0) {
            const valorString = res.data.result[0].valor;
            const parts = valorString.split('x');
            if (parts.length === 2) {
                const width = parseInt(parts[0], 10);
                const height = parseInt(parts[1], 10);
                if (!isNaN(width) && !isNaN(height)) {
                    return { width, height };
                }
            }
        }
    } catch (err) {
        console.error("Error al obtener parámetros de dimensión de imagen:", err);
    }
    return null; 
};

export const fetchImagePesoMaximo = async () => {
    const url = `${API_URL}ParametroUX/ListarParametrosPorCodigo/RECURSOS_IMG_MAXSIZE`; 
    const DEFAULT_MAX_MB = 1; 

    try {
        const res = await axios.get(url);
        if (res.data && res.data.isSucess && res.data.result && res.data.result.length > 0) {
            const valorString = res.data.result[0].valor; 
            const valorNumerico = parseFloat(valorString); 

            if (!isNaN(valorNumerico)) {
                if (valorNumerico >= 0.1 && valorNumerico <= 10) {
                    return valorNumerico; 
                }
            }
        }
        } catch (err) {
            console.error("Error al obtener el peso máximo de la imagen desde la API:", err);
        }

        return DEFAULT_MAX_MB; 
    };

    const getImageDimensions = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                resolve({ width: img.naturalWidth, height: img.naturalHeight });
                URL.revokeObjectURL(img.src);
            };
            img.onerror = () => {
                reject('Error al cargar la imagen.');
                URL.revokeObjectURL(img.src);
            };
            img.src = URL.createObjectURL(file);
        });
    };

    export const validateImageFile = async (file, imageDimensionLimits, weightLimitBytes) => {
        if (!file) return { ok: true };

        const { width: REQUIRED_WIDTH = 380, height: REQUIRED_HEIGHT = 401 } = imageDimensionLimits || {};
        
        if (weightLimitBytes && file.size > weightLimitBytes) {
            return { ok: false, message: `La imagen supera el límite de peso permitido.` };
        }

        try {
            const dimensions = await getImageDimensions(file);
            if (dimensions.width !== REQUIRED_WIDTH || dimensions.height !== REQUIRED_HEIGHT) {
                return { ok: false, message: `La imagen debe tener dimensiones de ${REQUIRED_WIDTH}x${REQUIRED_HEIGHT} píxeles.` };
            }
        } catch (error) {
            return { ok: false, message: "El archivo de imagen seleccionado no es válido o está corrupto." };
        }
        
        return { ok: true };
    };

    export const callCambiaEstado = async (component, event, valor, rolcrud, sComentarioEnv = "", onSuccessCallback = null) => {
        if (event) {
            if (typeof event.persist === 'function') event.persist();
            event.preventDefault();
        }

        const mapaEstados = {"Borrador": "R", "Por aprobar": "X", "Aprobar": "O", "Publicar": "P", "Rechazar": "Z", "Inactivar": "I"};
        let letra = mapaEstados[valor] || (component.state.resource.cEstado?.value || component.state.resource.cEstado);

        if (valor !== "GrabarCerrar" && ["X", "O", "P"].includes(letra) && !component.validarFormularioCompleto(letra)) 
        {
            // toast.error('Error: Revise los valores ingresados');
            return false; 
        }
        
        const estadoActualInterno = (component.state.resource && component.state.resource.cEstado && component.state.resource.cEstado.value) 
                                    ? component.state.resource.cEstado.value 
                                    : "R";

        const nAprobadorVal = component.state.resource.nAprobador?.value ?? component.state.resource.nAprobador;
        if ( valor !="GrabarCerrar" && !(letra === "R" || letra === "I") && (!nAprobadorVal || nAprobadorVal == 0 || nAprobadorVal == "0") ) {
            toast.error('Error: Debe seleccionar un Aprobador');
            return false;
        }
        
        let sComentario = sComentarioEnv; 
        if (valor !== "GrabarCerrar" && letra === "Z" && (!sComentario || sComentario.trim() === "")) 
        {
            toast.error('Error: Debe ingresar un motivo de rechazo');
            return false;
        }
        console.log("callCambiaEstado 2c: ")

        let v_SEOMostrarMotores = false;
        let v_SEOSeguirEnlace = false;
        let v_Activo = true; // Forzado según tu requerimiento

        if (letra === "P") {
            v_SEOMostrarMotores = true;
            v_SEOSeguirEnlace = true;
        }

        console.log("callCambiaEstado 3: ")
        if (valor !== "GrabarCerrar" && !(letra === "R" || letra === "I") && (!nAprobadorVal || nAprobadorVal == 0 || nAprobadorVal == "0") ) {
            toast.error('Error: Debe seleccionar un Aprobador');
            return false; 
        }
        
        const MAPA_ETIQUETAS = { "R": "Borrador", "X": "Por aprobar", "O": "Aprobado", "P": "Publicado", "Z": "Rechazado", "I": "Inactivo" };

        // Se captura el estado anterior antes del cambio optimista, para poder revertirlo
        // si el guardado en el servidor falla (ej. título duplicado) y el usuario permanece en la pantalla.
        const estadoAnterior = {
            cEstado: component.state.resource.cEstado,
            sEstado: component.state.resource.sEstado,
        };

        component.setState({ 
            resource: { 
                ...component.state.resource, 
                recu_SeoMostrarMotores: v_SEOMostrarMotores, 
                recu_SeoSeguirEnlace: v_SEOSeguirEnlace,
                cEstado: { value: letra, label: MAPA_ETIQUETAS[letra] }, 
                sEstado: MAPA_ETIQUETAS[letra], 
                sComentario: sComentario, 
                bActivo: v_Activo,
                sRolCRUD : rolcrud
            }
        }, () => { 
            component.callFunctionButton(event, letra="", sComentario="", valor, estadoAnterior, onSuccessCallback); //valor= modoCRUD
        });

    };

    export const cargarConfiguracionRoles = async () => {
        const urlAprobadores = `${API_URL}UsuarioUX/ObtenerUsuariosPorRol/${ROL_APROBADORES_DOCUMENTO}`;
        const urlPublicadores = `${API_URL}UsuarioUX/ObtenerUsuariosPorRol/${ROL_PUBLICADORES_DOCUMENTO}`;

        try {
            const [resAprob, resPubli] = await Promise.all([
                axios.get(urlAprobadores),
                axios.get(urlPublicadores)
            ]);

            const listAprobadores = resAprob.data.result.map(item => item.nUsuCodigo.toString()).join(',');
            const listPublicadores = resPubli.data.result.map(item => item.nUsuCodigo.toString()).join(',');

            const currentConfig = JSON.parse(localStorage.getItem('config') || '{}');
            const newConfig = {
                ...currentConfig,
                aprobador: listAprobadores,
                publicador: listPublicadores
            };

            localStorage.setItem('config', JSON.stringify(newConfig));
            return true;  

        } catch (error) {
            console.error("Error al cargar roles:", error);
            toast.error("¡Error al sincronizar permisos de usuario!");
            return false;  
        }
    };

    export const getCKEditorConfig = (isSuperAdmin) => {
        const baseConfig = {
            width :'100%',
            addCss: '.divImagenConBajada img{width: 100% !important;}',
            // Por defecto CKEditor 4 genera <em> al aplicar cursiva. Se sobreescribe a <i>, según lo requerido.
            coreStyles_italic: { element: 'i' },
            stylesSet : [
                { name: 'Enlace único', element: 'a', attributes: { 'class': 'enlaceUnico' } },
                { name: 'Botón rojo', element: 'a', attributes: { 'class': 'btnIrAlPortal' } },
                { name: 'Lista 2 Columnas', element: 'ul', attributes: { 'class': 'ListaEn2Columnas' } },
                { name: '1 Imagen Grande / Bajada', element: 'section',attributes: { 'class': 'divImagenConBajada' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
                { name: '2 Imagenes Pequeñas / Bajada', element: 'section',attributes: { 'class': 'divImagenMedianas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
                { name: '3 Imagenes Chiquitas / Bajada', element: 'section',attributes: { 'class': 'divImagenChiquitas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} }
            ],
            div_wrapTable : true,
            extraAllowedContent: 'section class iframe style video embed',
            allowedContent : true,
            image: {toolbar: [ 'imageTextAlternative' ]},
            extraPlugins : 'embed, iframe',
            embed_provider : '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback} ',
            skin : 'kama'
        };

        if (isSuperAdmin) {
            return {
                ...baseConfig,
                height: '600px',
                toolbarGroups: [
                    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    '/',
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'list', 'Outdent', 'blocks', 'align', 'bidi', 'paragraph','iframe' ,'Anchor'] },
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ],
                removeButtons: 'Save,NewPage,Preview,Print,Templates,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Subscript,Superscript,Strike,CopyFormatting,JustifyRight,BidiLtr,BidiRtl,Language,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,FontSize,Font,Maximize,ShowBlocks,About,Intent'
            };
        } 
        
        return {
            ...baseConfig,
            height: '400px',
            toolbar: [
                { name: 'clipboard', items: [ 'Cut', 'Undo', 'Redo' ] },
                { name: 'basicstyles', items: [ 'Bold', 'Italic', 'RemoveFormat' ] },
                { name: 'links', items: [ 'Link', 'Unlink' ] }
            ]
        };
    };
    